import React from 'react'
import PropTypes from 'prop-types'
import VideoProduct from './VideoProduct'
import FloorPlansProduct from './FloorPlansProduct'
import AdvertisingProduct from './AdvertisingProduct'
import StandardPhotoProduct from './StandardPhotoProduct'
import StylingProduct from './StylingProduct'
import SlideshowProduct from './SlideshowProduct'

const productComponents = {
  AdvertisingProduct,
  FloorPlansProduct,
  StandardPhotoProduct,
  StylingProduct,
  VideoProduct,
  SlideshowProduct,
}

 const SelectedProductOptions = ({product, productAvailability}) => {
  const ProductComponent = productComponents[product.__typename]

  if (ProductComponent) {
    return (
      <ProductComponent
        product={product}
        productAvailability={productAvailability}
      />
    )
  }

  return null
}

SelectedProductOptions.propTypes = {
  product: PropTypes.object.isRequired,
  productAvailability: PropTypes.object.isRequired,
}

export default SelectedProductOptions
